module.exports = __webpack_public_path__ + "img/Comercio_Build.e306c276.png";